export default {
  paper: {
    border: '1px solid #e5e5e5'
  }
}
